<mat-label class="subHeading">Varient</mat-label>
<mat-select class="varient" formControlName="variant" placeholder="All">
    <mat-option *ngFor="let varObj of variantList" [value]="varObj.rb_id">
        {{varObj.variant_name}}
    </mat-option>
</mat-select>